/**
 * Import required libraries
 */
import React from "react";
import labels from "./labels";

/**
 * Import required elements
 */
// Material-ui components
import {
  Paper,
  ClickAwayListener,
  MenuList,
  Popover,
  MenuItem,
  ListItem,
  ListItemIcon,
  ListItemText
} from "@material-ui/core";
// Material-ui icons
import DisconnectIcon from "@material-ui/icons/ExitToApp";
import styles from "./styles";

import { useHistory } from "react-router";
/**
 * MenuProfile Render JSX
 */
const MenuProfileRender = ({
  lang,
  pseudo,
  menuIsOpen,
  handleClose,
  buttonRef,
  disconnect,
  settings,
}) => {


  const history = useHistory();

  let list = [
    {
      key: "disconnect",
      onClick: disconnect,
      color: "secondary",
      Icon: DisconnectIcon
    }
  ];

  function backToProfile() {
    history.push(`/settings`)
    handleClose()
  }

  // CSS classnames
  const classes = styles();

  return (
    <Popover
      className={classes.popover}
      open={menuIsOpen}
      anchorEl={buttonRef}
      anchorOrigin={{
        vertical: "bottom",
        horizontal: "left"
      }}
      transformOrigin={{
        vertical: "top",
        horizontal: "left"
      }}
    >
      <Paper>
        <ClickAwayListener onClickAway={handleClose}>
          <MenuList>
            {pseudo && (
              <ListItem button onClick={backToProfile}>
                <ListItemText primary={pseudo} />
              </ListItem>
            )}
            {list.map(({ key, onClick, color, Icon }) => (
              <MenuItem key={key} onClick={onClick}>
                <ListItemIcon>
                  <Icon color={color} />
                </ListItemIcon>
                <ListItemText primary={labels[key][lang]} />
              </MenuItem>
            ))}
          </MenuList>
        </ClickAwayListener>
      </Paper>
    </Popover>
  );
};

export default MenuProfileRender;
